import styled from 'styled-components';

export const GridMobilStyle = styled.div`
  height: 90vh;
  padding: 2em;
  padding-top: 0;

  overflow: scroll;

  .gatsby-image-wrapper {
    height: 30vh;
    object-fit: contain;
  }

  .slick-arrow {
    margin-top: -1.5vh;
  }

  .slick-slider {
    width: 100%;
  }

  .slick-next {
    right: 0;
    ::before {
      content: '>';
    }
  }
  .slick-prev {
    z-index: 1;
    left: 0px;
    ::before {
      content: '<';
    }
  }

  .slick-dots {
    display: none !important;
  }

  .slick-prev,
  .slick-next {
    width: auto;
    height: auto;
  }
  .slick-prev::before,
  .slick-next::before {
    opacity: 0;
    /* width: 1.5vw;
    height: 1.5vw; */
    font-size: 4vh;
    display: flex;
    color: var(--blue);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
